import { SESSION_ERROR_PAGE } from './session.tracking.constants';
import { track } from './tracking';

export const trackErrorPagePresented = () => {
  track(SESSION_ERROR_PAGE);
};
